import(/* webpackMode: "eager" */ "/opt/fa-build/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/fa-build/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fa-build/src/components/pages/home/courseDetails/components/CourseDetailSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fa-build/src/components/pages/home/courseDetails/components/CourseHeroSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fa-build/src/components/pages/home/home/components/HelpSection.js");
